export default __webpack_public_path__ + "static/media/img3.8c6d1a5b.jpg";